export default "__VITE_ASSET__BsJIn23J__"